import React, { FC } from 'react';
import { Tab } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    fontSize: theme.typography.pxToRem(20),
    '@media (min-width: 960px)': {
      padding: `${theme.spacing(2)}px ${theme.spacing(5)}px`,
    },
  },
}));

const LargeTab: FC<any> = props => {
  const classes = useStyles(props);

  return <Tab {...props} className={classes.root} />;
};

export default LargeTab;
